import './globalAnnouncement.scss'
import { RichText } from '@cms/components/richText'
import { useStoreContext } from '@common/contexts/useStoreContext'
import { isWithinRange } from '@common/utils/date/isWithinRange'
import { getSessionStorage } from '@common/utils/session/getSessionStorage'
import { setSessionStorage } from '@common/utils/session/setSessionStorage'
import { Icon, useI18n } from '@vista-digital/occ-ui'
import { occUiVersion } from '@vista-digital/occ-ui/src/version'
import { observer } from 'mobx-react-lite'
import { type FC, useEffect } from 'react'
import { cmsDataService } from '@/content/services/cms.data.service'

const sessionKey = 'global-announcement-override'

export const GlobalAnnouncementComponent: FC = observer(() => {
    const { announcementsStore } = useStoreContext()
    const i18n = useI18n()

    const overrideGlobalAnnouncement = (): void => {
        setSessionStorage<boolean>(sessionKey, true)
        announcementsStore.setGlobalVisibility(false)
    }

    const data = cmsDataService.get().globalAnnouncement

    useEffect(() => {
        if (!data) return
        const { startDateTime, endDateTime, message } = data
        const withinRange = isWithinRange(startDateTime, endDateTime)
        const hasUserOverride = !!getSessionStorage<boolean>(sessionKey)
        const visible = withinRange && !hasUserOverride && !!message
        announcementsStore.setGlobalVisibility(visible)
    }, [announcementsStore, data])

    if (!data || !announcementsStore.isGlobalAnnouncementVisible) return null
    const { promotionName, message } = data

    const displayMessage = i18n.template(message, {
        appVersion: APP_VERSION,
        buildTime: new Date(APP_BUILD_TIME),
        occVersion: occUiVersion,
        connectVersion: cmsDataService.get()?.connectVersion,
    })

    return (
        <div className="global-announcement">
            <div className="container-lg-padding">
                <div className="global-announcement__content">
                    <h2 className="global-announcement__heading">{promotionName}</h2>
                    <RichText htmlText={displayMessage} />
                    <div className="close-button" onClick={overrideGlobalAnnouncement}>
                        <Icon name="cross" />
                    </div>
                </div>
            </div>
        </div>
    )
})
